<p-dialog
  [(visible)]="visible"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  [style]="{ 'max-width': '90vw', 'min-width': '70vw' }"
>
  <ng-template pTemplate="header">
    <div class="flex justify-start items-start flex-col">
      <h1 class="text-xl"><b>Vista de repositorio</b></h1>
      <small class="mb-4 italic opacity-80">
        <b>
          Aquí visualiza los adjuntos ya cargados, puede agregar los que están
          ya en su poder.
        </b>
      </small>
    </div>
  </ng-template>

  <div class="grid grid-cols-12 gap-5 pt-3">
    @for (adjunto of adjuntos; track $index) {
    <div
      class="lg:col-span-4 md:col-span-6 sm:col-span-12 col-span-12 flex justify-start items-center"
    >
      <div class="w-16 h-full relative flex justify-center items-center">
        @if (esImagen(adjunto)) {
        <p-image
          id="image"
          [src]="adjunto.adjunto ? url + adjunto.adjunto : 'svg/no-file.svg'"
          alt="Image"
          width="64"
          [preview]="true"
          class="rounded-lg"
          appendTo="body"
        />
        } @else {
        <img
          [src]="toggleImagen(adjunto)"
          alt="Image"
          width="64"
          class="rounded-lg"
        />
        }
      </div>
      <div class="pl-3 w-full">
        <p class="m-0 p-0">
          <small>
            {{
              adjunto
                ? adjunto.nombre_archivo
                : 'No se selecciono ningún archivo'
            }}
          </small>
        </p>
        <p
          class="text-blue-600 cursor-pointer"
          (click)="onEmitirAdjunto(adjunto)"
        >
          Seleccionar
        </p>
      </div>
    </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end">
      <petrol-button variant="tertiary" (click)="visible = false">Cerrar</petrol-button>
    </div>
  </ng-template>
</p-dialog>
